'use strict';

import React from 'react';
import { Text, Image, View } from 'react-native';
import ImageAssets from 'common/ImageAssets';
import CommonBridge from 'common/CommonBridge';
import { wrapStyle } from 'utils/computedStyle';

const styles = wrapStyle({
  loading: { width: { yp: 190, mi: 30 }, height: { yp: 190, mi: 30 } },
  text: {
    marginTop: 12,
    color: '#000',
    opacity: 0.5,
    fontSize: 12,
  },
});
const LoadingView = React.memo((props) => {
  const { style, text } = props;
  const containerStyle = {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff',
    ...style,
  };
  return (
    <View style={containerStyle}>
      <Image
        style={styles.loading}
        resizeMode={'stretch'}
        source={CommonBridge.isMishop() ? ImageAssets.Common.LoadingMi() : ImageAssets.Common.LoadingYp}
      />
      <View>{text && <Text style={styles.text}>{text}</Text>}</View>
    </View>
  );
});

export { LoadingView };
